import { createFocusTrap } from '../../node_modules/focus-trap/dist/focus-trap.esm.js'
import PhotoSwipeLightbox from '../../node_modules/photoswipe/dist/photoswipe-lightbox.esm.js'
import PhotoSwipe from '../../node_modules/photoswipe/dist/photoswipe.esm.js'

const customGoTo = (index, animate = false) => {
	const ctx = lightbox.pswp
	index = ctx.getLoopedIndex(index)
	const indexChanged = ctx.mainScroll.moveIndexBy(
		index - ctx.potentialIndex,
		animate
	)

	if (indexChanged) {
		ctx.dispatch('afterGoto')
	}
}

const leftArrowSVGString =
	'<svg aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9.46 4.46l-7 6.99c-.3.29-.3.76-.01 1.06 .29.29.76.29 1.06 0l7-7c.29-.3.29-.77 0-1.07 -.3-.3-.77-.3-1.07-.01Zm-7.01 8.06l7 7c.29.29.76.29 1.06 0 .29-.3.29-.77 0-1.07l-7-7c-.3-.3-.77-.3-1.07 0 -.3.29-.3.76 0 1.06Zm.53.21h18c.41 0 .75-.34.75-.75 0-.42-.34-.75-.75-.75h-18c-.42 0-.75.33-.75.75 0 .41.33.75.75.75Z"/></svg>'
const rightArrowSVGString =
	'<svg aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M3 12.74h18c.41 0 .75-.34.75-.75 0-.42-.34-.75-.75-.75H3c-.42 0-.75.33-.75.75 0 .41.33.75.75.75Zm18.53-1.29l-7-7c-.3-.3-.77-.3-1.07 0 -.3.29-.3.76 0 1.06l7 6.99c.29.29.76.29 1.06-.01 .29-.3.29-.77-.01-1.07Zm-1.07 0l-7 7c-.3.29-.3.76 0 1.06 .29.29.76.29 1.06 0l7-7c.29-.3.29-.77 0-1.07 -.3-.3-.77-.3-1.07 0Z"/></svg>'
const closeSVGString =
	'<svg aria-hidden="true" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m14 1.41-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z"/></svg>'

const lightbox = new PhotoSwipeLightbox({
	gallery: '[data-gallery]',
	children: 'a.c-figure__link',
	showHideAnimationType: 'zoom',
	arrowNextSVG: rightArrowSVGString,
	arrowPrevSVG: leftArrowSVGString,
	zoom: false,
	closeSVG: closeSVGString,
	bgOpacity: 0.9,
	pswpModule: PhotoSwipe,
	paddingFn: (viewportSize) => ({
		top: 64,
		bottom: 64,
		left: 64,
		right: 64,
	}),
	mainClass: 'c-pswp',
})
lightbox.init()

lightbox.on('uiRegister', () => {
	lightbox.pswp.next = () => customGoTo(lightbox.pswp.potentialIndex + 1, true)
	lightbox.pswp.prev = () => customGoTo(lightbox.pswp.potentialIndex - 1, true)

	lightbox.pswp.ui.registerElement({
		name: 'custom-caption',
		order: 9,
		isButton: false,
		appendTo: 'root',
		html: 'Caption text',
		onInit: (el, pswp) => {
			lightbox.pswp.on('change', () => {
				const currSlideElement =
					lightbox.pswp.currSlide.data.element.closest('figure')
				let captionHTML = ''
				if (currSlideElement) {
					const hiddenCaption =
						currSlideElement.querySelector('.c-figure__caption')
					if (hiddenCaption) {
						// get caption from element with class hidden-caption-content
						captionHTML = hiddenCaption.innerHTML
					} else {
						// get caption from alt attribute
						captionHTML = currSlideElement
							.querySelector('img')
							.getAttribute('alt')
					}
				}
				el.innerHTML = captionHTML || ''
			})
		},
	})
})

let galleryFocusTrap

// Enable focus trap on gallery open
lightbox.on('openingAnimationStart', () => {
	galleryFocusTrap = createFocusTrap('.pswp__scroll-wrap')
	galleryFocusTrap.activate()
})

// Disable focus trap on gallery close
lightbox.on('close', () => {
	galleryFocusTrap.deactivate()
})
